module.exports = __webpack_public_path__ + "media/images/app/colors/colors-yellow-3a8daf42a74c0be84fc56dbe2e83d8e4.webp";